import { Box, Button, Icon, Typography, ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

interface TypographyWithIconProps {
  mb?: number;
  variant?:
    | "inherit"
    | "button"
    | "overline"
    | "caption"
    | "body2"
    | "body1"
    | "subtitle2"
    | "subtitle1"
    | "h6"
    | "h5"
    | "h4"
    | "h3"
    | "h2"
    | "h1";
  iconLigature: string;
  boxClass?: string;
  classesIcon?: string;
  typographyClass?: string;
  children?: React.ReactNode;
  outlined?: boolean;
  rightButtonText?: string;
  rightButtonProps?: ButtonProps;
}

export const TypographyWithIcon: React.FC<TypographyWithIconProps> = ({
  mb = 2,
  variant = "caption",
  iconLigature,
  boxClass = "",
  classesIcon = "",
  typographyClass = "",
  children,
  outlined = false,
  rightButtonText = undefined,
  rightButtonProps = undefined,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Box mb={mb} display="flex" className={boxClass}>
      <Typography
        variant={variant}
        className={`flex items-center ${typographyClass}`}
        {...props}
      >
        <Icon className={`text-[20px] ${classesIcon}`}>
          {outlined ? (
            <span className="material-icons-outlined text-[20px]">
              {iconLigature}
            </span>
          ) : (
            iconLigature
          )}
        </Icon>
        <span className="ml-1">{children}</span>
      </Typography>
      {rightButtonProps && (
        <Button size="medium" className="ml-auto p-0" {...rightButtonProps}>
          {rightButtonText ?? (
            <Box display="flex">
              <AddOutlinedIcon />
              <Typography className="text-blue-500 ml-1" variant="caption">
                {t("Common.Add")}
              </Typography>
            </Box>
          )}
        </Button>
      )}
    </Box>
  );
};
